var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiftiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg18",
    viewBox: "0 0 1440 380.31866",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs22"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,285.239 H 1080 V 0 H 0 Z",
    id: "path32"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,380.31867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g30",
    clipPath: "url(#clipPath34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g36",
    transform: "translate(151.2646,29.3274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -119.527 v 239.833 c 0,8.838 -7.232,16.07 -16.07,16.07 -8.437,0 -15.668,-7.232 -15.668,-16.07 V -13.258 c 0,-8.838 7.231,-16.069 15.668,-16.069 H 0 c 8.035,0 14.463,6.428 14.463,14.463 C 14.463,-6.83 8.035,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "translate(269.9189,285.2385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -8.437,0 -15.669,-7.231 -15.669,-16.069 v -253.1 c 0,-8.838 7.232,-16.069 15.669,-16.069 8.837,0 16.068,7.231 16.068,16.069 v 253.1 C 16.068,-7.231 8.837,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(824.6182,285.2385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -168.941 c -8.036,0 -14.866,-6.829 -14.866,-14.864 0,-8.035 6.83,-14.463 14.866,-14.463 h 68.399 V -269.16 c 0,-8.838 7.232,-16.069 16.07,-16.069 8.839,0 16.071,7.231 16.071,16.069 V -29.327 H 0 c 8.034,0 14.863,6.428 14.863,14.463 C 14.863,-6.829 8.034,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(943.6729,285.2385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -8.437,0 -15.669,-7.231 -15.669,-16.069 v -253.1 c 0,-8.838 7.232,-16.069 15.669,-16.069 8.838,0 16.068,7.231 16.068,16.069 v 253.1 C 16.068,-7.231 8.838,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "translate(553.6953,285.2385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -148.854 c -8.035,0 -14.463,-6.829 -14.463,-14.864 0,-8.035 6.428,-14.463 14.463,-14.463 H 0 c 8.035,0 14.463,6.83 14.463,14.865 C 14.463,-6.428 8.035,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(503.8237,153.4666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -98.982 c -8.035,0 -14.463,-6.83 -14.463,-14.865 v -122.532 c 0,-8.838 7.231,-16.069 15.668,-16.069 8.839,0 16.069,7.231 16.069,16.069 v 108.07 H 0 c 8.035,0 14.463,6.829 14.463,14.865 C 14.463,-6.428 8.035,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g60",
    transform: "translate(1064.1318,31.7366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -8.764,0 -15.868,-7.104 -15.868,-15.868 0,-8.764 7.104,-15.868 15.868,-15.868 8.764,0 15.868,7.104 15.868,15.868 C 15.868,-7.104 8.764,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiftiLogo);
export default __webpack_public_path__ + "static/media/lifti-logo.3dbcf50f764ca1f0dcfc31d622c1ece7.svg";
export { ForwardRef as ReactComponent };